import { render, staticRenderFns } from "./upload-pesticide-exam.vue?vue&type=template&id=212fd5e9"
import script from "./upload-pesticide-exam.vue?vue&type=script&lang=ts"
export * from "./upload-pesticide-exam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports